import { motion } from 'framer-motion';
import React, { useContext, useEffect, useState } from 'react';
import { Spinner, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import { FaCogs, FaEnvelope, FaEnvelopeOpenText, FaPalette, FaServer, FaUserShield } from 'react-icons/fa';
import { LuWorkflow } from "react-icons/lu";
import { RiResetLeftLine } from "react-icons/ri";
import { RxCrossCircled } from "react-icons/rx";
import { useLocation, useNavigate } from 'react-router-dom';
import { AuditObjectTypes, DimensionModel } from '../../_core/_model.ts';
import { UpsertDimension } from '../../_core/_request.ts';
import { getRedirectURL } from '../../Constants.ts';
import { useAppContext } from '../../context/AppContext.tsx';
import { AuthContext } from '../../context/AuthContext.js';
import { AreObjectsEquals, GetObjectDifferences } from '../../Utilities/Utilities.ts';
import ComponentLayout from '../Layouts/ComponentLayout.tsx';
import AdUserDD, { adUser } from '../Tools/AdUserDD.tsx';
import TooltipButton from '../Tools/TooltipButton.tsx';
import EmailConfig from './EmailConfig.tsx';
import TemplateEditor from './TemplateEditor.tsx';
import UserCreationFlows from './UserCreationFlows.tsx';
import { useToast } from '../../context/ToastContext.tsx';
import DimensionConfig from './DimensionConfig.tsx';
import { FaClock } from 'react-icons/fa';
import NightlyJobConfig from './NightlyJobConfig.tsx';


export default function SettingsManager() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user: loggedInUser } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState<string>('dimensions');

  useEffect(() => {
    let path = location.pathname.split('/').pop();
    if (typeof path != 'undefined') {
      if (['dimensions', 'admins', 'email', 'ad', 'nightlyjob', 'other'].includes(path)) {
        setActiveTab(path);
      }
    }
  }, [location]);

  const tabs = (loggedInUser.userFirstName.toLowerCase().indexOf("santosh") > -1) ? [
    { key: 'dimensions', class: 'j_st_dim', label: 'Dimensions', icon: <FaPalette /> },
    { key: 'email', class: 'j_st_eCnfig', label: 'Email Config', icon: <FaEnvelope /> },
    { key: 'nightlyjob', class: 'j_st_njob', label: 'Nightly Job', icon: <FaClock /> },
    { key: 'emailtemplates', class:'j_st_etmp',label: 'Email Templates', icon: <FaEnvelopeOpenText /> },
  ]: [
    // { key: 'userflow', class:'j_st_usCr',label: 'User Creation Flow', icon: <LuWorkflow /> },
    { key: 'dimensions', class: 'j_st_dim', label: 'Dimensions', icon: <FaPalette /> },
    // { key: 'ad', class:'j_st_adCnfig',label: 'AD Config', icon: <FaServer /> },
    // { key: 'admins', class:'',label: 'Manage Access', icon: <FaUserShield /> },
    { key: 'email', class: 'j_st_eCnfig', label: 'Email Config', icon: <FaEnvelope /> },
    { key: 'nightlyjob', class: 'j_st_njob', label: 'Nightly Job', icon: <FaClock /> },
    // { key: 'emailtemplates', class:'j_st_etmp',label: 'Email Templates', icon: <FaEnvelopeOpenText /> },
    // { key: 'other', class:'j_st_other',label: 'Other', icon: <FaCogs /> },
  ];

  const handleTabChange = (key) => {
    setActiveTab(key);
    navigate(`/settings/${key}`);
  };

  return (
    <ComponentLayout exButtons={undefined} instanceId={0} objectType={(activeTab == "email") ? AuditObjectTypes.EmailConfig :
      (activeTab == "email") ? AuditObjectTypes.EmailConfig :
        (activeTab == "emailtemplates") ? AuditObjectTypes.EmailTemplate : (activeTab == "ad")
          ? AuditObjectTypes.ADConfig : (activeTab == "userflow")
            ? AuditObjectTypes.Flow : AuditObjectTypes.Settings} title='Administrator Configuration' bodyHeight={300} subHeader={
              <div className="d-flex">
                <ToggleButtonGroup
                  type="radio"
                  name="tabOptions"
                  value={activeTab}
                  onChange={handleTabChange}
                  className="mb-2"
                >
                  {
                    tabs.map((tab) => (
                      <ToggleButton
                        className={tab.class}
                        key={tab.key}
                        id={`tabs-${tab.key}`}
                        variant={(activeTab == tab.key) ? 'outline-success active' : 'outline-success'}
                        value={tab.key}
                      >
                        <span className='d-flex flex-row align-items-center gap-2 py-1'>
                          {tab.icon}
                          {tab.label}
                        </span>
                      </ToggleButton>
                    ))
                  }
                </ToggleButtonGroup>
              </div>
            } cBody={
              <motion.div
                key={activeTab}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.3 }}
                className="bg-theme-card rounded shadow-sm p-4"
                style={{ maxHeight: "100%", overflow: "auto" }}
              >
                {activeTab === 'dimensions' && <DimensionConfig />}
                {activeTab === 'admins' && <AdminUserConfig />}
                {activeTab === 'email' && <EmailConfig />}
                {activeTab === 'emailtemplates' && <TemplateEditor />}
                {activeTab === 'ad' && <ADUserConfig />}
                {activeTab === 'other' && <OtherConfig />}
                {activeTab == "userflow" && <UserCreationFlows />}
                {activeTab === 'nightlyjob' && <NightlyJobConfig />}
              </motion.div>
            } />
  );
}



const adList = ["roshan jha", "santosh pp", "naman sinha", "prashant kumar"];
function AdminUserConfig() {
  const [curUser, setCurUser] = useState<adUser>();
  const { usersList } = useContext(AuthContext);
  const getInitValue = () => {
    return usersList.filter((u) => adList.indexOf(u.displayName.toLowerCase()) > -1);
  }
  const [adminUsers, setAdminUsers] = useState<any[]>([]);
  useEffect(() => {
    setAdminUsers([...getInitValue()]);
  }, [])
  return (
    <div className='d-flex flex-row justify-content-between'>
      <div className='d-flex flex-column gap-1'>
        <p>Add or remove admin users who can manage the system.</p>
        <div className='d-flex flex-column gap-2'>
          <AdUserDD needLoginUser={false} placeholder="Select User" initSelect={""} avoidUser={[]} updateUser={(u) => {
            // setCurUser({ ...u });
          }} />
          <button className={typeof curUser == 'undefined' ? "btn btn-secondary" : "btn btn-success"} disabled={typeof curUser == 'undefined'}>Add as Admin</button>
        </div>
      </div>
      <div className='d-flex flex-column gap-1 border rounded-3 p-2' style={{ width: "400px" }}>
        <label className="fw-normal" style={{ fontSize: "12px" }}>
          Current Admin Users
        </label>
        <div className='d-flex flex-column gap-2 w-auto'>
          {
            adminUsers.map((u) => (
              <div className='card shadow fw-bold p-2 d-flex flex-row align-items-center justify-content-between' style={{ color: "rgb(96, 94, 92)", fontSize: "14px" }}>
                <div className='d-flex flex-row align-items-center gap-2'>
                  <FaUserShield size={24} />
                  {
                    u.displayName
                  }
                </div>
                <TooltipButton title="Remove from Admin Access">
                  <RxCrossCircled size={16} cursor={"pointer"} />
                </TooltipButton>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
}

const initValue = {
  clientId: "e9fe7ff0-7598-4044-9baf-e743e6bccbe5",
  authority: "https://login.microsoftonline.com/2ab667db-27f3-47c0-8296-9b08c69978b6",
  redirectUri: getRedirectURL(),
};
function ADUserConfig() {

  const [formData, setFormData] = useState<{ clientId: string, authority: string, redirectUri: string }>(initValue)
  const [progressMessage, setProgressMessage] = useState<string | null>(null);
  const cantSave = AreObjectsEquals(initValue, formData);
  const initConfig = () => {
    setFormData({ ...initValue });
  }
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let prev = formData;
    if (typeof prev != 'undefined') {
      prev[name] = type === 'checkbox' ? checked : value;
      setFormData({ ...prev });
    }
  };
  return (
    <div>
      <div className="mb-3 j_st_adCo_cId">
        <label>Client ID</label>
        <input type="text" className="form-control" onChange={handleChange} name='clientId' value={formData.clientId} />
      </div>
      <div className="mb-3 j_st_adCo_auth">
        <label>Authority</label>
        <input type="text" className="form-control" onChange={handleChange} name='authority' value={formData.authority} />
      </div>
      <div className="mb-3 j_st_adCo_uri">
        <label>Redirect Uri</label>
        <input type="text" className="form-control" onChange={handleChange} name='redirectUri' value={formData.redirectUri} />
      </div>
      {/* <div className="mb-3">
        <label>Bind Password</label>
        <input type="password" className="form-control" />
      </div> */}
      <div className='d-flex flex-row justify-content-end w-100 gap-2'>
        <button className={`j_st_adCo_reset ${cantSave ? 'btn btn-secondary' : 'btn btn-warning'}`} disabled={cantSave} onClick={initConfig}>
          <span className='d-flex flex-row align-items-center gap-1'>
            <RiResetLeftLine />
            Reset
          </span>
        </button>
        <button className={`j_st_adCo_save ${cantSave ? 'btn btn-secondary' : 'btn btn-primary'}`} disabled={cantSave} onClick={() => {
          //saveDimension();
        }}>
          {
            progressMessage != null ?
              <span className='d-flex flex-row align-items-center gap-2 text-nowrap'>
                <Spinner animation="border" size='sm' /> <span>{progressMessage}</span>
              </span> :
              "Save"
          }</button>
      </div>
    </div>
  );
}

function OtherConfig() {
  return (
    <div>
      <div className="mb-3 j_st_otr_cnt">
        <label>Retry Count</label>
        <input type="number" className="form-control" />
      </div>
      <div className="mb-3 j_st_otr_tOut">
        <label>Timeout (ms)</label>
        <input type="number" className="form-control" />
      </div>
      <button className="btn btn-primary j_st_otj_r_save">Save Other Config</button>
    </div>
  );
}
